<!--
 * @Author: Gaho
 * @Date: 2024-01-04 18:53:30
 * @LastEditors: Merlin
 * @LastEditTime: 2024-12-02 14:51:07
 * @Description: 
-->
<template>
    <!-- ↓ 已经改为使用渐变显示图 -->
    <img class="blue-light" />
</template>

<script setup lang="ts">


</script>

<style lang="scss" scoped>
.blue-light {
    left: 50%;
    position: absolute;
    top: 21%;
    transform: translate(-50%, -50%) scale(1.5);
    width: 715px;
    height: 412px;
    content: radial-gradient(rgba(0, 72, 200, 1) 0%, rgba(0, 72, 185, 0) 65%);
    @media (max-width: 550px) {
        transform: translate(-50%, -34%) scale(1.8);
    }
}   

</style>
